import React from 'react';
import { motion } from 'framer-motion';
import { CourseCard } from '../components/CourseCard';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const allCourses = [{
  title: 'Awakening the Inner Light',
  image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1999&auto=format&fit=crop',
  date: 'Oct 15 - Oct 20',
  duration: '5 Days',
  description: 'A transformative journey into the depths of your consciousness. Learn ancient breathing techniques and guided meditation to awaken your spiritual energy.',
  slug: '/course/awakening-inner-light'
}, {
  title: 'Mindfulness for Modern Life',
  image: 'https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?q=80&w=2072&auto=format&fit=crop',
  date: 'Nov 02 - Nov 04',
  duration: '3 Days',
  description: 'Practical tools to maintain peace amidst chaos. This course bridges ancient wisdom with modern psychology to help you navigate daily stress.',
  slug: '#'
}, {
  title: 'Silent Retreat: The Void',
  image: 'https://images.unsplash.com/photo-1545389336-cf090694435e?q=80&w=2071&auto=format&fit=crop',
  date: 'Dec 10 - Dec 17',
  duration: '7 Days',
  description: 'Immerse yourself in total silence. Disconnect from the digital world and reconnect with the subtle sounds of nature and your own being.',
  slug: '#'
}, {
  title: 'Chakra Healing Intensive',
  image: 'https://images.unsplash.com/photo-1528319725582-ddc096101511?q=80&w=2070&auto=format&fit=crop',
  date: 'Jan 08 - Jan 12',
  duration: '5 Days',
  description: 'Deep dive into the seven energy centers. Learn to identify blockages, activate dormant energy, and restore balance to your entire system.',
  slug: '#'
}, {
  title: 'Yoga & Meditation Fusion',
  image: 'https://images.unsplash.com/photo-1544367563-12123d8965cd?q=80&w=2070&auto=format&fit=crop',
  date: 'Feb 14 - Feb 18',
  duration: '5 Days',
  description: 'Integrate physical asana practice with deep meditation. Experience the synergy of movement and stillness for complete mind-body harmony.',
  slug: '#'
}, {
  title: 'Advanced Pranayama Workshop',
  image: 'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?q=80&w=2525&auto=format&fit=crop',
  date: 'Mar 05 - Mar 07',
  duration: '3 Days',
  description: 'Master advanced breathing techniques from the yogic tradition. Harness the power of breath to transform energy and consciousness.',
  slug: '#'
}, {
  title: 'Vipassana: The Art of Seeing',
  image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=2070&auto=format&fit=crop',
  date: 'Apr 10 - Apr 20',
  duration: '10 Days',
  description: 'Traditional Vipassana meditation retreat. Observe reality as it is through sustained practice of mindful awareness and equanimity.',
  slug: '#'
}, {
  title: 'Mantra & Sound Healing',
  image: 'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?q=80&w=1964&auto=format&fit=crop',
  date: 'May 15 - May 17',
  duration: '3 Days',
  description: 'Explore the transformative power of sacred sound. Learn ancient mantras and experience healing through vibration and resonance.',
  slug: '#'
}, {
  title: 'Meditation Teacher Training',
  image: 'https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?q=80&w=2072&auto=format&fit=crop',
  date: 'Jun 01 - Jun 30',
  duration: '30 Days',
  description: 'Comprehensive training to become a certified meditation instructor. Learn teaching methodology, philosophy, and develop your own practice.',
  slug: '#'
}];
export function AllCoursesPage() {
  return <div className="min-h-screen bg-[#FFFBF5]" data-id="element-325">
      <Header data-id="element-326" />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#8B9D83]/10 via-[#FAF7F2] to-[#B8A4C9]/10" data-id="element-327">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-328">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center max-w-3xl mx-auto" data-id="element-329">
            <h1 className="font-serif text-5xl md:text-6xl text-[#2C3E50] mb-6 leading-tight" data-id="element-330">
              Upcoming Courses
            </h1>
            <p className="text-xl text-[#5D6D7E] leading-relaxed" data-id="element-331">
              Explore our comprehensive range of meditation retreats, workshops,
              and training programs designed to support your spiritual journey
              at every stage.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Courses Grid */}
      <section className="py-20 bg-white" data-id="element-332">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-333">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-334">
            {allCourses.map((course, index) => <CourseCard key={index} {...course} delay={index * 0.1} data-id="element-335" />)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#FAF7F2]" data-id="element-336">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-337">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-338">
            <h2 className="font-serif text-4xl text-[#2C3E50] mb-6" data-id="element-339">
              Not Sure Which Course to Choose?
            </h2>
            <p className="text-lg text-[#5D6D7E] mb-10" data-id="element-340">
              Our team is here to help you find the perfect program for your
              needs and experience level.
            </p>
            <button className="bg-[#8B9D83] hover:bg-[#7A8C72] text-white px-12 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg" data-id="element-341">
              Get Course Recommendations
            </button>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-342" />
    </div>;
}